const $ = jQuery;
class PropertyAjax {
    constructor() {
        if (typeof acadiaAjax === 'undefined') {
            console.error('AJAX settings not found');
            return;
        }

        this.propertyList = $('.c-row_property_list');
        this.searchForm = $('#property-search-form');
        this.searchInput = $('#property-search');
        this.currentPage = parseInt(this.propertyList.data('current-page')) || 1;
        this.totalPosts = parseInt(this.propertyList.data('total-posts')) || 0;
        this.postsPerPage = 12;
        this.isLoading = false;
        this.ajaxUrl = acadiaAjax.ajaxurl;
        this.nonce = acadiaAjax.nonce;

        // Get default SF range from data attributes
        const $rangeSlider = $('.range-slider');
        this.defaultSfMin = parseInt($rangeSlider.data('min-sf')) || 0;
        this.defaultSfMax = parseInt($rangeSlider.data('max-sf')) || 1000;

        this.availabilityToggles = $('.c-toggle.cc-availability');
        this.availabilityToggleCont = $('.c-toggle_cont.cc-availability');
        this.activeFilters = {
            search: '',
            sf_min: this.defaultSfMin,
            sf_max: this.defaultSfMax,
            states: [],
            metro_areas: [],
            cities: [],
            property_types: [],
            agents: [],
            property_status: [],
            show_available: false
        };

        // Add new properties for filter reveal
        this.filterRevealBtn = $('#property-filter-reveal');
        this.filterForm = $('.c-filter_cont');
        this.filterTabs = $('.c-filter_tab');
        this.isFilterVisible = false;

        // Add debounce for filter application
        this.debouncedFilter = this.debounce(this.filterProperties.bind(this), 300);
        
        // Track ongoing animations
        this.currentAnimation = null;

        this.init();

        // Add event listener for map pin clicks
        $(document).on('mapPinFilter', (event, data) => {
            this.filterByMapPin(data.city, data.state);
        });
    }

    init() {
        this.initFilters();
        this.bindEvents();
        this.loadInitialFilters();
    }

    bindEvents() {
        $(window).on('scroll', () => {
            this.handleScroll();
        });

        this.searchForm.on('submit', (e) => {
            e.preventDefault();
            const searchQuery = this.searchInput.val();
            this.activeFilters.search = searchQuery;
            this.updateUrl();
            this.filterProperties();

            // Scroll to property list if it exists on the page
            const propertyList = document.getElementById('property-list');
            if (propertyList) {
                propertyList.scrollIntoView({ behavior: 'smooth' });
            }
        });

        // Add debounced input handler for live search
        let timeout = null;
        this.searchInput.on('input', (e) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                const searchQuery = e.target.value;
                this.activeFilters.search = searchQuery;
                this.updateUrl();
                this.filterProperties();
            }, 500);
        });

        // Listen for property updates
        $(document).on('propertyUpdate', (event, data) => {
            if (data.isNewSearch || data.isFilter) {
                this.propertyList.html(data.html);
            } else {
                this.propertyList.append(data.html);
            }
            this.propertyList
                .attr('data-total-posts', data.foundPosts)
                .attr('data-current-page', 1);
            this.currentPage = 1;
            this.updateTotalPosts(data.foundPosts);

            // Update property count span if it exists
            const $propertyCount = $('#property-count');
            if ($propertyCount.length) {
                $propertyCount.text(`(${data.foundPosts})`);
            }
        });

        // Listen for load more updates
        $(document).on('propertyLoadMore', (event, data) => {
            this.propertyList.append(data.html);
            this.propertyList.attr('data-current-page', data.page);
            this.currentPage = data.page;
        });

        // Listen for map accordion being opened
        document.addEventListener('mapAccordionOpened', () => {
            if (this.isFilterVisible) {
                this.toggleFilterReveal();
            }
        });

        // Handle filter form submission on mobile - only close the accordion
        $('#property-filter-form').on('submit', (e) => {
            e.preventDefault();
            if (this.isFilterVisible) {
                this.toggleFilterReveal();
                
            }
        });

        // Update checkbox handler to handle clicks on the entire filter option div
        $('.c-filter_option').on('click', function(e) {
            // Get the checkbox within this filter option
            const $checkbox = $(this).find('input[type="checkbox"]');
            
            // Toggle checkbox state
            $checkbox.prop('checked', !$checkbox.prop('checked'));
            
            // Toggle active class based on new checkbox state
            $(this).toggleClass('active', $checkbox.prop('checked'));
            
            // Trigger the change event on the checkbox to maintain existing functionality
            $checkbox.trigger('change');
            
            // Prevent event from triggering multiple times
            e.preventDefault();
        });

        // Update existing checkbox change handler
        $('.c-filter_option input[type="checkbox"]').on('change', (e) => {
            e.stopPropagation();
            $(e.target).closest('.c-filter_option').toggleClass('active', e.target.checked);
            this.updateActiveFilters();
            this.updateUrl();
            this.debouncedFilter();
        });

        // Handle SF range slider
        $('#sf-slider').on('slidestop', () => {
            this.activeFilters.sf_min = parseInt($('#sf-min-input').val());
            this.activeFilters.sf_max = parseInt($('#sf-max-input').val());
            this.updateUrl();
            this.debouncedFilter();
        });

        // Add click outside handler
        $(document).on('click', (e) => {
            if (!$(e.target).closest('.c-filter_tab').length) {
                this.closeAllFilters();
            }
        });

        // Add resize handler for filter content visibility
        $(window).on('resize', () => {
            if (window.innerWidth > 991) {
                gsap.set($('.c-filter_cont'), { clearProps: "all" });
            }
        });

        // Update filter header click handlers
        $('.c-filter_header').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $header = $(this);
            const $content = $header.next('.c-filter_content');
            const $options = $content.find('.c-filter_option');
            const $svg = $header.find('.c-svg_cont');
            
            // Close other open filters
            $('.c-filter_header').not($header).each(function() {
                const $otherHeader = $(this);
                const $otherContent = $otherHeader.next('.c-filter_content');
                if ($otherHeader.attr('aria-expanded') === 'true') {
                    $otherHeader.removeClass('active').attr('aria-expanded', 'false');
                    gsap.to($otherContent, {
                        height: 0,
                        opacity: 0,
                        duration: 0.3,
                        ease: 'power2.in',
                        onComplete: () => {
                            $otherContent.css('display', 'none');
                        }
                    });
                    
                    // Reset other SVGs with fade animation
                    const tl = gsap.timeline();
                    tl.to($otherHeader.find('.c-svg_cont'), {
                        opacity: 0,
                        duration: 0.15,
                        ease: 'power2.in'
                    })
                    .set($otherHeader.find('.c-svg_cont'), {
                        rotation: 0
                    })
                    .to($otherHeader.find('.c-svg_cont'), {
                        opacity: 1,
                        duration: 0.15,
                        ease: 'power2.out'
                    });
                }
            });
            
            // Toggle aria-expanded
            const isExpanded = $header.attr('aria-expanded') === 'true';
            $header.attr('aria-expanded', !isExpanded);
            
            if (!isExpanded) {
                // Add active class to header
                $header.addClass('active');
                
                // Show the content first to get proper measurements
                $content.css('display', 'block');
                
                // Animate dropdown
                gsap.fromTo($content, 
                    { height: 0, opacity: 0 },
                    { 
                        height: 'auto', 
                        opacity: 1, 
                        duration: 0.4,
                        ease: 'power2.out'
                    }
                );
                
                // Animate options
                const currentContent = $header.next('.c-filter_content');
                if (!currentContent.hasClass('filter-opened')) {
                    const optionsTimeline = gsap.timeline();
                    optionsTimeline.fromTo($options, 
                        { 
                            opacity: 0,
                            y: 20
                        },
                        { 
                            opacity: 1,
                            y: 0,
                            duration: 0.4,
                            stagger: 0.05,
                            ease: 'power2.out'
                        }
                    ).call(() => {
                        currentContent.addClass('filter-opened');
                    });
                }
                
                // Animate SVG with fade out, rotate, fade in sequence
                const tl = gsap.timeline();
                tl.to($svg, {
                    opacity: 0,
                    duration: 0.15,
                    ease: 'power2.in'
                })
                .set($svg, {
                    rotation: 180
                })
                .to($svg, {
                    opacity: 1,
                    duration: 0.15,
                    ease: 'power2.out'
                });
            } else {
                // Remove active class from header
                $header.removeClass('active');
                
                // Animate closing
                gsap.to($content, {
                    height: 0,
                    opacity: 0,
                    duration: 0.3,
                    ease: 'power2.in',
                    onComplete: () => {
                        $content.css('display', 'none');
                    }
                });
                
                // Animate SVG back with fade out, rotate, fade in sequence
                const tl = gsap.timeline();
                tl.to($svg, {
                    opacity: 0,
                    duration: 0.15,
                    ease: 'power2.in'
                })
                .set($svg, {
                    rotation: 0
                })
                .to($svg, {
                    opacity: 1,
                    duration: 0.15,
                    ease: 'power2.out'
                });
            }
        });

        // Update availability toggle handler
        this.availabilityToggles.on('change', (e) => {
            // Prevent the event from triggering multiple times
            e.stopPropagation();
            
            // Get the current state from the changed toggle
            const isChecked = $(e.target).prop('checked');
            
            // Update all toggles to match (this will sync mobile and desktop)
            this.availabilityToggles.prop('checked', isChecked);
            
            // Update toggle container classes
            this.availabilityToggleCont.toggleClass('active', isChecked);
            
            // Update active filters
            this.activeFilters.show_available = isChecked;
            
            // Update URL and filter properties
            this.updateUrl();
            this.filterProperties();
        });

        // Add filter reveal button handler
        this.filterRevealBtn.on('click', (e) => {
            e.preventDefault();
            this.toggleFilterReveal();
        });
    }

    initFilters() {
        this.initSFRangeSlider();
    }

    initSFRangeSlider() {
        const $slider = $('#sf-slider');
        const $minInput = $('#sf-min-input');
        const $maxInput = $('#sf-max-input');
        const $minDisplay = $('#sf-min');
        const $maxDisplay = $('#sf-max');
        const $resetButton = $('.js-reset-sf');

        if ($slider.length === 0) return;

        const min = parseInt($minInput.val()) || this.defaultSfMin;
        const max = parseInt($maxInput.val()) || this.defaultSfMax;
        const step = Math.ceil((max - min) / 100);

        $slider.slider({
            range: true,
            min: min,
            max: max,
            values: [min, max],
            step: step,
            slide: (event, ui) => {
                $minInput.val(ui.values[0]);
                $maxInput.val(ui.values[1]);
                $minDisplay.text(this.formatNumber(ui.values[0]));
                $maxDisplay.text(this.formatNumber(ui.values[1]));
                this.checkSFFilterActive();

                // Set availability toggle to true when slider is adjusted
                if (!this.availabilityToggles.prop('checked')) {
                    this.availabilityToggles.prop('checked', true);
                    this.availabilityToggleCont.addClass('active');
                    this.activeFilters.show_available = true;
                }
            }
        });

        // Handle reset button click
        $resetButton.on('click', () => {
            this.resetSFFilter();
        });

        // Check if SF filter is active on load
        this.checkSFFilterActive();
    }

    checkSFFilterActive() {
        const $resetButton = $('.js-reset-sf');
        const currentMin = parseInt($('#sf-min-input').val());
        const currentMax = parseInt($('#sf-max-input').val());
        
        // Show reset button if values are different from defaults
        if (currentMin > this.defaultSfMin || currentMax < this.defaultSfMax) {
            $resetButton.show();
        } else {
            $resetButton.hide();
        }
    }

    resetSFFilter() {
        const $slider = $('#sf-slider');
        const $minInput = $('#sf-min-input');
        const $maxInput = $('#sf-max-input');
        const $minDisplay = $('#sf-min');
        const $maxDisplay = $('#sf-max');
        const $resetButton = $('.js-reset-sf');

        // Reset slider values
        $slider.slider('values', [this.defaultSfMin, this.defaultSfMax]);
        $minInput.val(this.defaultSfMin);
        $maxInput.val(this.defaultSfMax);
        $minDisplay.text(this.formatNumber(this.defaultSfMin));
        $maxDisplay.text(this.formatNumber(this.defaultSfMax));

        // Reset active filters
        this.activeFilters.sf_min = this.defaultSfMin;
        this.activeFilters.sf_max = this.defaultSfMax;

        // Hide reset button
        $resetButton.hide();

        // Update URL and trigger filter
        this.updateUrl();
        this.filterProperties();
    }

    loadInitialFilters() {
        // Load filters from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        
        // Load search query
        const searchQuery = urlParams.get('search');
        if (searchQuery) {
            this.searchInput.val(searchQuery);
            this.activeFilters.search = searchQuery;
        }

        // Load SF range and set availability toggle if needed
        const sfMin = parseInt(urlParams.get('sf_min')) || this.defaultSfMin;
        const sfMax = parseInt(urlParams.get('sf_max')) || this.defaultSfMax;
        
        if (sfMin > this.defaultSfMin || sfMax < this.defaultSfMax) {
            // Set SF values
            this.activeFilters.sf_min = sfMin;
            this.activeFilters.sf_max = sfMax;
            $('#sf-min-input').val(sfMin);
            $('#sf-max-input').val(sfMax);
            $('#sf-min').text(this.formatNumber(sfMin));
            $('#sf-max').text(this.formatNumber(sfMax));
            $('#sf-slider').slider('values', [sfMin, sfMax]);
            this.checkSFFilterActive();

            // Set availability toggle to true if not already set
            if (!this.availabilityToggles.prop('checked')) {
                this.availabilityToggles.prop('checked', true);
                this.availabilityToggleCont.addClass('active');
                this.activeFilters.show_available = true;
            }
        }

        // Load states
        const states = urlParams.get('states');
        if (states) {
            const stateArray = states.split(',');
            stateArray.forEach(state => {
                const $checkbox = $(`input[name="state[]"][value="${state}"]`);
                $checkbox.prop('checked', true);
                $checkbox.closest('.c-filter_option').addClass('active');
            });
            this.activeFilters.states = stateArray;
        }

        // Load metro areas
        const metroAreas = urlParams.get('metro_areas');
        if (metroAreas) {
            const metroArray = metroAreas.split(',');
            metroArray.forEach(metro => {
                const $checkbox = $(`input[name="metro_area[]"][value="${metro}"]`);
                $checkbox.prop('checked', true);
                $checkbox.closest('.c-filter_option').addClass('active');
            });
            this.activeFilters.metro_areas = metroArray;
        }

        // Load cities
        const cities = urlParams.get('cities');
        if (cities) {
            const cityArray = cities.split(',');
            cityArray.forEach(city => {
                const $checkbox = $(`input[name="city[]"][value="${city}"]`);
                $checkbox.prop('checked', true);
                $checkbox.closest('.c-filter_option').addClass('active');
            });
            this.activeFilters.cities = cityArray;
        }

        // Load property types
        const propertyTypes = urlParams.get('property_types');
        if (propertyTypes) {
            const propertyTypeArray = propertyTypes.split(',');
            propertyTypeArray.forEach(type => {
                const $checkbox = $(`input[name="property_type[]"][value="${type}"]`);
                $checkbox.prop('checked', true);
                $checkbox.closest('.c-filter_option').addClass('active');
            });
            this.activeFilters.property_types = propertyTypeArray;
        }

        // Load agents
        const agents = urlParams.get('agents');
        if (agents) {
            const agentArray = agents.split(',');
            agentArray.forEach(agent => {
                const $checkbox = $(`input[name="agent[]"][value="${agent}"]`);
                $checkbox.prop('checked', true);
                $checkbox.closest('.c-filter_option').addClass('active');
            });
            this.activeFilters.agents = agentArray;
        }

        // Load availability toggle state and update both toggles
        const showAvailable = urlParams.get('show_available');
        if (showAvailable === 'true') {
            this.availabilityToggles.prop('checked', true);
            this.availabilityToggleCont.addClass('active');
            this.activeFilters.show_available = true;
        }

        // Apply initial filters if any are active
        if (this.hasActiveFilters()) {
            this.filterProperties();
        }
    }

    getCheckedValues(name) {
        return Array.from(document.querySelectorAll(`input[name="${name}"]:checked`))
            .map(input => input.value);
    }

    updateActiveFilters() {
        this.activeFilters.states = this.getCheckedValues('state[]');
        this.activeFilters.metro_areas = this.getCheckedValues('metro_area[]');
        this.activeFilters.cities = this.getCheckedValues('city[]');
        this.activeFilters.property_types = this.getCheckedValues('property_type[]');
        this.activeFilters.agents = this.getCheckedValues('agent[]');
        this.activeFilters.property_status = this.getCheckedValues('property_status[]');
    }

    hasActiveFilters() {
        return this.activeFilters.search !== '' ||
            this.activeFilters.sf_min > this.defaultSfMin ||
            this.activeFilters.sf_max < this.defaultSfMax ||
            this.activeFilters.states.length > 0 ||
            this.activeFilters.metro_areas.length > 0 ||
            this.activeFilters.cities.length > 0 ||
            this.activeFilters.property_types.length > 0 ||
            this.activeFilters.agents.length > 0 ||
            this.activeFilters.property_status.length > 0;
    }

    updateUrl() {
        const url = new URL(window.location);
        const params = new URLSearchParams();

        // Add search query
        if (this.activeFilters.search) {
            params.set('search', this.activeFilters.search);
        }

        // Add SF range only if it's different from default
        if (this.activeFilters.sf_min > this.defaultSfMin) {
            params.set('sf_min', this.activeFilters.sf_min);
        }
        if (this.activeFilters.sf_max < this.defaultSfMax) {
            params.set('sf_max', this.activeFilters.sf_max);
        }

        // Add other filters
        if (this.activeFilters.states.length > 0) {
            params.set('states', this.activeFilters.states.join(','));
        }
        if (this.activeFilters.metro_areas.length > 0) {
            params.set('metro_areas', this.activeFilters.metro_areas.join(','));
        }
        if (this.activeFilters.cities.length > 0) {
            params.set('cities', this.activeFilters.cities.join(','));
        }
        if (this.activeFilters.property_types.length > 0) {
            params.set('property_types', this.activeFilters.property_types.join(','));
        }
        if (this.activeFilters.agents.length > 0) {
            params.set('agents', this.activeFilters.agents.join(','));
        }
        if (this.activeFilters.property_status.length > 0) {
            params.set('property_status', this.activeFilters.property_status.join(','));
        }

        // Add availability toggle state
        if (this.activeFilters.show_available) {
            params.set('show_available', 'true');
        }

        // Update URL without reloading the page
        window.history.pushState({}, '', `${url.pathname}?${params.toString()}`);
    }

    handleScroll() {
        const scrollPosition = $(window).scrollTop() + $(window).height();
        const threshold = $(document).height() - 2000;

        if (scrollPosition > threshold) {
            this.loadMoreProperties();
        }
    }

    async filterProperties(page = 1) {
        if (this.isLoading) return;
        this.isLoading = true;

        try {
            // Add loading class to container
            this.propertyList.addClass('loading');

            // Kill any ongoing animations
            if (this.currentAnimation) {
                this.currentAnimation.kill();
                this.currentAnimation = null;
            }

            // Fade out the entire container
            await new Promise(resolve => {
                this.currentAnimation = gsap.to(this.propertyList, {
                    opacity: 0,
                    duration: 0.3,
                    ease: 'power2.in',
                    onComplete: () => {
                        this.currentAnimation = null;
                        resolve();
                    }
                });
            });

            // Create the data object with all filters
            const data = {
                action: 'filter_properties',
                security: this.nonce,
                page: page,
                search: this.activeFilters.search,
                states: this.activeFilters.states,
                metro_areas: this.activeFilters.metro_areas,
                cities: this.activeFilters.cities,
                property_types: this.activeFilters.property_types,
                agents: this.activeFilters.agents,
                property_status: this.activeFilters.property_status,
                show_available: this.activeFilters.show_available
            };

            // Only add SF parameters if they differ from defaults
            if (this.activeFilters.sf_min > this.defaultSfMin) {
                data.sf_min = this.activeFilters.sf_min;
            }
            if (this.activeFilters.sf_max < this.defaultSfMax) {
                data.sf_max = this.activeFilters.sf_max;
            }

            const response = await $.ajax({
                url: this.ajaxUrl,
                type: 'POST',
                data: data
            });

            if (response.success) {
                // Update content
                this.propertyList.html(response.data.html);
                
                // Fade in the new content
                this.currentAnimation = gsap.to(this.propertyList, {
                    opacity: 1,
                    duration: 0.3,
                    ease: 'power2.out',
                    onComplete: () => {
                        this.currentAnimation = null;
                    }
                });

                $(document).trigger('propertyUpdate', {
                    html: response.data.html,
                    foundPosts: response.data.found_posts,
                    maxPages: response.data.max_pages,
                    isFilter: true
                });
            }
        } catch (error) {
            console.error('Error filtering properties:', error);
        } finally {
            // Remove loading class
            this.propertyList.removeClass('loading');
            this.isLoading = false;
        }
    }

    async loadMoreProperties() {
        if (this.isLoading) return;
        
        const loadedPosts = this.currentPage * this.postsPerPage;
        if (loadedPosts >= this.totalPosts) return;

        this.isLoading = true;
        const nextPage = this.currentPage + 1;

        try {
            // Create the data object with all filters
            const data = {
                action: 'filter_properties',
                security: this.nonce,
                page: nextPage,
                search: this.activeFilters.search,
                states: this.activeFilters.states,
                metro_areas: this.activeFilters.metro_areas,
                cities: this.activeFilters.cities,
                property_types: this.activeFilters.property_types,
                agents: this.activeFilters.agents,
                property_status: this.activeFilters.property_status,
                show_available: this.activeFilters.show_available
            };

            // Only add SF parameters if they differ from defaults
            if (this.activeFilters.sf_min > this.defaultSfMin) {
                data.sf_min = this.activeFilters.sf_min;
            }
            if (this.activeFilters.sf_max < this.defaultSfMax) {
                data.sf_max = this.activeFilters.sf_max;
            }

            const response = await $.ajax({
                url: this.ajaxUrl,
                type: 'POST',
                data: data
            });

            if (response.success) {
                $(document).trigger('propertyLoadMore', {
                    html: response.data.html,
                    page: nextPage
                });
            }
        } catch (error) {
            console.error('Error loading more properties:', error);
        } finally {
            this.isLoading = false;
        }
    }

    updateCurrentPage(page) {
        this.currentPage = page;
    }

    updateTotalPosts(total) {
        this.totalPosts = total;
    }

    formatNumber(num) {
        return new Intl.NumberFormat().format(num);
    }

    // Add new method to close all filters
    closeAllFilters() {
        $('.c-filter_header').each(function() {
            const $header = $(this);
            const $content = $header.next('.c-filter_content');
            const $svg = $header.find('.c-svg_cont');
            
            if ($header.attr('aria-expanded') === 'true') {
                $header.removeClass('active').attr('aria-expanded', 'false');
                
                gsap.to($content, {
                    height: 0,
                    opacity: 0,
                    duration: 0.3,
                    ease: 'power2.in',
                    onComplete: () => {
                        $content.css('display', 'none');
                    }
                });
                
                // Update SVG animation in closeAllFilters
                const tl = gsap.timeline();
                tl.to($svg, {
                    opacity: 0,
                    duration: 0.15,
                    ease: 'power2.in'
                })
                .set($svg, {
                    rotation: 0
                })
                .to($svg, {
                    opacity: 1,
                    duration: 0.15,
                    ease: 'power2.out'
                });
            }
        });
    }

    filterByMapPin(city, state) {
        // Reset all filters
        this.activeFilters = {
            search: '',
            sf_min: this.defaultSfMin,
            sf_max: this.defaultSfMax,
            states: [state],
            metro_areas: [],
            cities: [city.toLowerCase()],
            property_types: [],
            agents: [],
            property_status: [],
            show_available: false
        };

        // Clear search input
        this.searchInput.val('');

        // Clear all checkboxes
        $('.c-filter_option input[type="checkbox"]').prop('checked', false)
            .closest('.c-filter_option').removeClass('active');

        // Set the correct checkboxes
        $(`input[name="state[]"][value="${state}"]`).prop('checked', true)
            .closest('.c-filter_option').addClass('active');
        
        $(`input[name="city[]"][value="${city.toLowerCase()}"]`).prop('checked', true)
            .closest('.c-filter_option').addClass('active');

        // Reset SF range
        this.resetSFFilter();

        // Update URL and filter properties
        this.updateUrl();
        this.filterProperties();
    }

    // Add new method to handle filter reveal animation
    toggleFilterReveal() {
        if (!this.isFilterVisible) {
            // Show the filter container first but with height 0
            this.filterForm.css({
                display: 'flex',
                height: 'auto',
                opacity: 0
            });
            
            // Get the natural height
            const height = this.filterForm.outerHeight();
            
            // Set back to 0 height for animation
            this.filterForm.css({
                height: 0
            });

            // Add active class to button
            this.filterRevealBtn.addClass('active');
            
            // Animate the container height and opacity
            gsap.to(this.filterForm, {
                height: height,
                opacity: 1,
                duration: 0.5,
                ease: 'power2.out',
                onComplete: () => {
                    // Clean up inline styles after animation
                    this.filterForm.css({
                        height: '',
                        opacity: ''
                    });
                    // refresh scroll trigger
                    if (typeof ScrollTrigger !== 'undefined') {
                        ScrollTrigger.refresh();
                    }
                    
                    // Dispatch custom event
                    document.dispatchEvent(new CustomEvent('filtersToggled', { 
                        detail: { opened: true } 
                    }));
                }
            });

            // Animate filter tabs with stagger
            gsap.fromTo(this.filterTabs, 
                {
                    y: 30,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.4,
                    stagger: 0.05,
                    ease: 'power2.out',
                    delay: 0.1 // Slight delay to start after container begins opening
                }
            );

        } else {
            // Remove active class from button
            this.filterRevealBtn.removeClass('active');

            // Animate out filter tabs
            gsap.to(this.filterTabs, {
                y: -10,
                opacity: 0,
                duration: 0.3,
                stagger: {
                    amount: 0.03,
                    from: 'end',
                    ease: 'power2.out'
                },
                ease: 'power2.in'
            });

            // Animate the container closed
            gsap.to(this.filterForm, {
                height: 0,
                opacity: 0,
                duration: 0.4,
                ease: 'power2.in',
                delay: 0.2, // Slight delay to let tabs animate out first
                onComplete: () => {
                    this.filterForm.css({
                        display: 'none',
                        height: '',
                        opacity: ''
                    });
                    
                    // Refresh ScrollTrigger
                    if (typeof ScrollTrigger !== 'undefined') {
                        ScrollTrigger.refresh();
                    }
                    
                    // Dispatch custom event
                    document.dispatchEvent(new CustomEvent('filtersToggled', { 
                        detail: { opened: false } 
                    }));
                }
            });
        }

        // Toggle state
        this.isFilterVisible = !this.isFilterVisible;
    }

    // Add debounce utility
    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
}

export default PropertyAjax;
